import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-computer",
  "use": "icon-computer-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-computer\"><path d=\"M554.666667 691.2l81.066666 81.066667-59.733333 59.733333L512 768l-68.266667 68.266667L384 776.533333l85.333333-85.333333V640H170.666667V213.333333h298.666666V170.666667h85.333334v42.666666h298.666666v426.666667h-298.666666v51.2zM256 298.666667v256h512V298.666667H256z\" p-id=\"8166\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol